<template>
  <div>
    <div class="iotplt-card-box">
      <search-cpe-goods @submit="submitSearch" />
    </div>

    <div style="padding-top: 15px">
      <a-empty v-if="!loading && products.length === 0" />

      <a-row :gutter="24" v-else>
        <a-col :span="8">
          <supplier-card
            :data="products"
            title="CPE商品"
            :loading="loading"
          />
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { findCpeGoods } from '@/api/cpe_goods'
import SearchCpeGoods from '@/views/agent_purchase_items/cpe_goods/Search'
import SupplierCard from '@/views/agent_purchase_items/cpe_goods/SupplierCard'

export default {
  name: 'CpeGoodsList',
  components: {
    SearchCpeGoods,
    SupplierCard
  },
  data() {
    return {
      loading: true,
      products: [],
      query: {}
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    submitSearch(search) {
      this.query = Object.assign({}, this.$options.data().query, search)
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findCpeGoods(
        Object.assign({ agent_id: this.$store.getters.userAgentId }, this.query)
      ).then((res) => {
        if (res.code === 0) {
          this.products = res.data || []
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>
